import Vue from 'vue'
import Vuex from 'vuex'
import axios,{API_URL} from './helpers/axios'

//--------modulos---------------------
import globals from './modules/global'
import login from './modules/login'
// import mensaje from './modules/mensaje';
import mensajeSis from './modules/mensajeSistema'
import loading from './modules/loading'
// Event for menu
import eventMenu from './modules/eventMenu'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    globals,
    login,
    mensajeSis,
    loading,
    eventMenu
    

  },

  state: {
    alumno: false,  
    idprueba: [],
    tituloMenu: null,
    logo: `${API_URL}/${sessionStorage.ruta_avatar_persona}${sessionStorage.avatar_persona}`,
    // Loader o spinner Jesus A
    // Objetos de loadingSpiner table circularbar
    hearChangeTab: false,
    loadingSpiner: {
      titulo: "",
      estado: false,
      color: "danger",
      colorDialog: "red",
      ancho: "600",
    },
    tabEstudiante: [],
  },

  getters: {
      getLogo:(state)=>{
          return state.logo;
      },
    
    getTituloMenu: (state) => {
      return state.tituloMenu;
    },
  },

  mutations: {
    getArrayTab: (state, array) => {
      state.tabEstudiante = array;
    },
    // Mutaciones de loadingSpiner Table circular
    changedStateTab(state) {
      state.hearChangeTab = true;

      setTimeout(() => {
        state.hearChangeTab = false;
      }, 15000);
    },
    // "animate__animated animate__heartBeat"
    changedAnimationTab(state, payload) {
      state.tabEstudiante[1].class = payload.classAnimate;
      setTimeout(() => {
        state.tabEstudiante[1].class = "";
      }, 800);
    },
    mostrarLoading(state, payload) {
      state.loadingSpiner.titulo = payload.titulo;
      state.loadingSpiner.color = payload.color;
      state.loadingSpiner.estado = true;
      state.loadingSpiner.colorDialog = payload.colorDialog;
      state.loadingSpiner.ancho = payload.ancho;
    },
    ocultarLoading(state) {
      state.loadingSpiner.estado = false;
    },
    // FIN JESUS
    setLogo(state,payload){
        state.logo = payload.url;
    },
   
    setTituloMenu(state, titulo) {
      state.tituloMenu = titulo;
    },
  },

  actions: {
    /* LogoUrl(){
        return state.logo;
    }, */
   
  },
});
